import {$, T} from "../../common/drupal/drupal";
/**
 * Class for toggling content
 */
class Toggle {

    /**
     * init
     */
    init(){
        $('.toggle-title').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.toggle').toggleClass('opened').find('.toggle-content').slideToggle(500);
        });
    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context)) {
            this.init();
        }
    }
}

export let toggle = new Toggle();
